import { Link } from "react-router-dom";
import { Gift, ChevronRight } from "lucide-react";

export const MugThanksSection = () => (
  <section className="max-w-3xl mx-auto overflow-hidden rounded-[2rem] bg-[#121212] text-white ring-1 ring-amber-300/25 shadow-xl shadow-amber-900/20" data-testid="cs-mug-thanks">
    <div className="grid sm:grid-cols-[14rem_1fr]">
      <img src="/merch/tasse-gold.jpg" alt="Dankeschön-Tasse Black & Gold" className="w-full h-56 sm:h-full object-cover" />
      <div className="p-6 space-y-3">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-amber-300 flex items-center gap-1.5"><Gift className="w-4 h-4" /> Ab 100 € Unterstützung</p>
        <h3 className="font-display text-2xl font-black bg-gradient-to-r from-amber-100 via-amber-300 to-amber-500 bg-clip-text text-transparent">Unsere Dankeschön-Tasse für dich</h3>
        <p className="text-sm text-white/75">Unterstützt du die Community mit mindestens 100 € auf einmal, schenken wir dir unsere Tasse „Black &amp; Gold“ mit dem goldenen Herz-Logo – kostenlos zu dir nach Hause geschickt.</p>
        <Link to="/tasse" className="inline-flex items-center gap-1 h-10 pl-4 pr-3 rounded-full bg-gradient-to-r from-amber-300 to-amber-500 text-[#3a2508] text-sm font-black" data-testid="cs-mug-more">Mehr zur Tasse <ChevronRight className="w-4 h-4" /></Link>
      </div>
    </div>
  </section>
);
